<script lang="ts">
  import { onMount } from 'svelte';
  import { Copy, Check } from 'lucide-svelte';

  export let code: string;
  export let language: string = 'javascript';
  
  let copied = false;
  let codeElement: HTMLElement;

  function copyCode() {
    navigator.clipboard.writeText(code.trim());
    copied = true;
    
    setTimeout(() => {
      copied = false;
    }, 2000);
  }

  onMount(() => {
    // soon
  });
</script>

<div class="code-block glass">
  <div class="code-header">
    <span class="language">{language}</span>
    <button on:click={copyCode} class="copy-button" aria-label="Copy code">
      {#if copied}
        <Check size={16} />
        <span class="tooltip">Copied!</span>
      {:else}
        <Copy size={16} />
        <span class="tooltip">Copy</span>
      {/if}
    </button>
  </div>
  <pre bind:this={codeElement}><code class={language}>{code}</code></pre>
</div>

<style>
  .code-block {
    margin: var(--spacing-md) 0;
    border-radius: var(--border-radius);
    overflow: hidden;
    position: relative;
  }

  .code-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-xs) var(--spacing-md);
    background: rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid var(--glass-border);
  }

  .language {
    font-size: 0.875rem;
    color: var(--text-secondary);
    text-transform: uppercase;
  }

  .copy-button {
    background: transparent;
    border: none;
    color: var(--text-secondary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-xs);
    border-radius: var(--border-radius-small);
    position: relative;
    transition: all 0.3s ease;
  }

  .copy-button:hover {
    background: rgba(255, 255, 255, 0.05);
    color: var(--text-primary);
  }

  .tooltip {
    position: absolute;
    top: -30px;
    right: 0;
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    padding: 4px 8px;
    border-radius: var(--border-radius-small);
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }

  .copy-button:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }

  pre {
    margin: 0;
    padding: var(--spacing-md);
    overflow-x: auto;
    font-family: 'SF Mono', Consolas, Monaco, 'Andale Mono', monospace;
    font-size: 0.875rem;
    line-height: 1.6;
  }

  code {
    color: var(--text-primary);
    background: transparent;
    display: block;
  }
</style> 